// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSuccess_root__2NVcB","fillColor":"IconSuccess_fillColor__3m4ag"};